import React from 'react';

const ProcessingLoader = ({ isOpen, message, details }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-sm w-full mx-4 animate-in fade-in duration-200">
        <div className="p-8 text-center">
          {/* Spinner animé */}
          <div className="relative mx-auto mb-6 w-16 h-16">
            {/* Cercle de fond */}
            <div className="absolute inset-0 rounded-full border-4 border-gray-200"></div>
            
            {/* Cercle animé */}
            <div className="absolute inset-0 rounded-full border-4 border-blue-600 border-t-transparent animate-spin"></div>
            
            {/* Icône au centre */}
            <div className="absolute inset-0 flex items-center justify-center">
              <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
          </div>

          {/* Message principal */}
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            {message || 'Traitement en cours...'}
          </h3>
          
          {/* Détails */}
          {details && (
            <p className="text-sm text-gray-600 mb-4">{details}</p>
          )}
          
          {/* Steps indicator */}
          <div className="space-y-2">
            <div className="flex items-center justify-between text-xs text-gray-500">
              <span>Création de la souscription</span>
              <svg className="w-4 h-4 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="flex items-center justify-between text-xs text-gray-500">
              <span>Génération du proforma</span>
              <div className="w-4 h-4 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
            </div>
            <div className="flex items-center justify-between text-xs text-gray-300">
              <span>Envoi par email</span>
              <div className="w-4 h-4 border-2 border-gray-300 rounded-full"></div>
            </div>
          </div>

          <p className="text-xs text-gray-400 mt-6">
            Veuillez patienter, cela peut prendre quelques instants...
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProcessingLoader;